import { createFileRoute } from "@tanstack/react-router";

import ProxyTesterPage from "../-components/ProxyTesterPage";

export const Route = createFileRoute("/_app/_dashboard/proxy-tester")({
  component: ProxyTesterPage,
});
